module.exports = (__webpack_require__(1))(408);


//////////////////
// WEBPACK FOOTER
// delegated ./lib/rlink-router/__globalBuildContextForLegacySupport__.js from dll-reference rlink_core
// module id = 22
// module chunks = 0